import { createStyles } from "src/styles/theme";

export type StylesClasses = keyof typeof styles;

const styles = createStyles({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    backgroundImage: "url('/assets/images/logInBackground.jpeg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
  logInWrapper: {
    width: {
      lg: "40%",
      sm: "60%",
      xs: "80%",
    },
    maxWidth: "500px",
    height: "auto",
    borderRadius: "24px",
    padding: "28px 34px",
    position: "relative",
    backgroundColor: "white",
  },
  noAccount: {
    fontSize: "13px",
    fontWeight: 400,
    color: "#8D8D8D",
    whiteSpace: "nowrap",
    textAlign: "center",
  },

  signUp: {
    color: "custom.text.label",
    fontSize: "13px",
    fontWeight: 400,
    cursor: "pointer",
  },
  welcomeBox: {
    textAlign: "center",
    marginBottom: "40px",
  },
  accountBox: {
    display: "flex",
    flexDirection: "column",
    width: "80px",
  },
  logo: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "1%",
    marginBottom: "20px",
  },
  login: {
    fontSize: "36px",
    fontWeight: 600,
  },
  welcomeSpan: {
    fontSize: "21px",
    fontWeight: 600,
    color: "#779341",
  },
  welcomeMessage: {
    fontSize: "18px",
    color: "custom.text.light",
  },
  title: {
    color: "custom.text.label",
    fontFamily: "Inter",
    fontSize: "21.722px",
    fontWeight: 600,
  },
  heading: {
    fontSize: "50px",
    fontWeight: 600,
    marginBottom: "16px",
  },

  loginFields: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    margin: "16px 0px 20px 0px",
  },

  forgetPassword: {
    textAlign: "right",
    color: "custom.text.label",
    cursor: "pointer",
    marginBottom: "40px",
  },
  input: {},
  password: {},
  loginBtn: {
    width: "206px",
    height: "44px",
    margin: "auto",
  },
});

export default styles;
